import React from 'react'
import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const Input = styled(TextFieldMui)`
  margin: 0 !important;
  height: 2.3rem;
`

export const NumberFormatStyles: React.CSSProperties = {
  margin: 0,
  height: 40,
}

export const ButtonSubmit = styled(ButtonMui)`
  width: 11rem;
  height: 2.3rem;
  margin: 0 !important;
`

export const ItemContainer = styled.div`
  display: grid; 
  grid-template-columns: 0.3fr 0.3fr 0.3fr 0.3fr 0.3fr 0.5fr;
  grid-template-rows: 50px;
  gap: 16px;
  margin-bottom: 1.2em;
`
